<template>
  <p class="copyright">
    {{ copLabel }} &copy; {{ copYear }}
    <span>{{ copDesc }}</span>
  </p>
</template>

<script>
  
export default {
    name: "FPCopyright",
    props: {
      copLabel: {
        type: String,
        required: true
      },
      copDesc: {
        type: String,
        required: true
      }
    },
    computed: {
      copYear () {
        return (new Date()).getFullYear();
      }
    }
  }
</script>